var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { label, labelWithSupportingText, radio, labelText, labelTextWithSupportingText, supportingText, } from './styles';
const LabelText = ({ hasSupportingText, children, }) => {
    return (_jsx("div", Object.assign({ css: (theme) => [
            hasSupportingText ? labelTextWithSupportingText : '',
            labelText(theme.radio && theme),
        ], className: "src-radio-label-text" }, { children: children }), void 0));
};
const SupportingText = ({ children }) => {
    return (_jsx("div", Object.assign({ css: (theme) => supportingText(theme.radio && theme) }, { children: children }), void 0));
};
/**
 * [Storybook](https://guardian.github.io/source/?path=/docs/source-src-radio-radio--demo) •
 * [Design System](https://theguardian.design/2a1e5182b/p/2891dd-radio-button/b/46940d) •
 * [GitHub](https://github.com/guardian/source/tree/main/src/core/components/radio) •
 * [NPM](https://www.npmjs.com/package/@guardian/src-radio)
 *
 * Radio buttons allow users to make a single selection from a set of options.
 *
 * The following themes are supported: `default`, `brand`
 */
export const Radio = (_a) => {
    var { label: labelContent, value, supporting, checked, defaultChecked, cssOverrides } = _a, props = __rest(_a, ["label", "value", "supporting", "checked", "defaultChecked", "cssOverrides"]);
    const isChecked = () => {
        if (checked != null) {
            return checked;
        }
        return !!defaultChecked;
    };
    const radioControl = (_jsx("input", Object.assign({ type: "radio", css: (theme) => [radio(theme.radio && theme), cssOverrides], value: value, "aria-checked": isChecked(), defaultChecked: defaultChecked != null ? defaultChecked : undefined, checked: checked != null ? isChecked() : undefined }, props), void 0));
    const labelledRadioControl = (_jsxs("label", Object.assign({ css: (theme) => [
            label(theme.radio && theme),
            supporting ? labelWithSupportingText : '',
        ] }, { children: [radioControl, supporting ? (_jsxs("div", { children: [_jsx(LabelText, Object.assign({ hasSupportingText: true }, { children: labelContent }), void 0),
                    _jsx(SupportingText, { children: supporting }, void 0)] }, void 0)) : (_jsx(LabelText, { children: labelContent }, void 0))] }), void 0));
    return (_jsx(_Fragment, { children: labelContent || supporting ? labelledRadioControl : radioControl }, void 0));
};
//# sourceMappingURL=Radio.js.map
